import React from 'react';

// ChatSidebar collapsed state component - minimal expand button
// Extracted from ChatSidebar.jsx lines 879-905
const ChatCollapsedView = ({ darkMode, onToggleCollapse, className = "" }) => {
  return (
    <div className={`
      flex items-center justify-center
      ${darkMode ? 'bg-gray-900 border-gray-700' : 'bg-white border-gray-200'}
      ${className}
      md:flex-col md:h-full md:w-12 md:border-l md:bg-gray-50 md:dark:bg-gray-900
      w-12 h-12 rounded-full shadow-lg
    `}>
      <button
        onClick={onToggleCollapse}
        className={`
          p-2 rounded-lg transition-colors w-full h-full flex items-center justify-center
          ${darkMode 
            ? 'hover:bg-gray-800 text-gray-400 hover:text-gray-200' 
            : 'hover:bg-gray-200 text-gray-500 hover:text-gray-700'
          }
          md:rounded-lg rounded-full
        `}
        title="Expand SEO Assistant"
      >
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-3.582 8-8 8a8.955 8.955 0 01-1.946-.274A5.978 5.978 0 015.074 16H2v-2c0-4.418 3.582-8 8-8s8 3.582 8 8z" />
        </svg>
      </button>
    </div>
  );
};

export default ChatCollapsedView;
